import * as React from "react";

function SvgIcons8EditProperty(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M4 5v22h13.063l-.688 3.469-.313 1.468 1.47-.312 3.53-.688.313-.062 9.75-9.75c1.16-1.16 1.16-3.09 0-4.25A3.002 3.002 0 0029 16c-.344 0-.672.07-1 .188V5zm2 2h20v2H6zm0 4h20v6.75L18.75 25H6zm3 3v2h2v-2zm4 0v2h10v-2zm-4 4v2h2v-2zm4 0v2h6v-2zm16 0c.254 0 .52.082.719.281a.977.977 0 010 1.407l-9.344 9.343-1.781.375.375-1.781 9.343-9.344c.2-.199.434-.281.688-.281z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8EditProperty);
